<template>
  <div class="custom-25" :style="{ backgroundColor: bgColor, color: color }">
    <div class="info-content">
      <div class="left">
        <div class="left-img">
          <img src="../../static/IM/six-questionnaire.png" alt="" />
        </div>
        <div class="left-content">
          <div class="title">{{ data.name }}</div> 
          <div class="descript">{{ data.remark }}</div>         
        </div>
      </div>
      <div class="right">
        <div class="btn" @click="showDialog">立即查看</div>
      </div>
    </div>
    <!-- 预览问卷弹窗 -->
    <PreviewDialog
    ref="dialogRef"
    :paramData="paramData"
    :imLook="true">
    </PreviewDialog>
  </div>
</template>

<script>
import PreviewDialog from '../RightContent/questionDialog';
import { selectListExam } from '../../api/crossApi'
export default {
  components: {
    PreviewDialog,//报告处理查看问卷
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    bgColor: {
      type: String,
      default: '#F5F5F5',
    },
    color: {
      type: String,
      default: '#333',
    },
  },
  data() {
    return {
      paramData: {}
    }
  },
  created() {},
  methods: {
    async showDialog() {
      let res = await selectListExam({
        answerSheetId: this.data.answerSheetId
      })
      if(res.code === 0){
        this.paramData = res.data
        this.$refs.dialogRef.showVisible()
      }else{
        this.$message.error(res.message)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.custom-25 {
  border-radius: 4px;
  width: 350px;
  border-radius: 4px;
  
  .info-content {
    padding: 15px 20px;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .left-img {
        margin-right: 15px;
        img {
          width: 60px;
          height: 60px;
        }
      }
      .left-content {
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: center;

        .title {
          font-size: 12px;
          font-weight: 600;
          color: #333;
        }
      }
    }
    .right{
      .btn{
        width: 62px;
        height: 27px;
        border-radius: 14px;
        border: 1px solid #0CB79F;

        font-size: 12px;
        color: #0CB79F;
        line-height: 27px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>